module.exports = __webpack_public_path__ + "img/more-info.d766e241.svg";